class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    const isMobileFacetForm = facetForm.id === 'FacetFiltersFormMobile';

    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));

  document.addEventListener('click', function (event) {

    // Filter checkbox
    const checkbox = event.target.closest(
        '#FacetFiltersFormMobile .mobile-facets__checkbox, #FacetFiltersFormMobile .swatch-input__input'
    );

    // Clear filters
    const clearFilter = event.target.closest(
        '#FacetFiltersFormMobile .mobile-facets__clear-wrapper a'
    );

    if (!checkbox && !clearFilter) return;

    const inner = document.querySelector(
        '#FacetFiltersFormMobile .mobile-facets__inner'
    );

    if (!inner) return;

    // Don't animate if Clear Filters is disabled
    if (clearFilter && clearFilter.classList.contains('disabled-clear-filter')) {
        return;
    }

    // Remove existing loader
    const oldLoader = inner.querySelector('.loader-line');

    if (oldLoader) {
        oldLoader.remove();
    }

    // Create loader
    const loader = document.createElement('div');
    loader.className = 'loader-line';

    inner.appendChild(loader);

    // Remove after 2 seconds
    setTimeout(() => {
        if (loader && loader.parentNode) {
            loader.remove();
        }
    }, 2000);
});

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    // document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

static initColgridJS() {

/*

=====================================================

IMAGE LIMIT

=====================================================
*/
const getProductImageLimit = () => {

/*
 * Image limiter disabled.
 */
if (!window.enable_img_limiter) {
  return null;
}

const limit =
  parseInt(window.img_limit, 10);

/*
 * Invalid limit.
 */
if (
  isNaN(limit) ||
  limit < 1
) {
  return null;
}

return limit;


};

/*

=====================================================

UPDATE PRODUCT CARD URL

=====================================================
*/
const updateProductCardUrl = ($productCard, $swatch) => {

if (
  !$productCard.length ||
  !$swatch.length
) {
  return;
}

const variantUrl =
  $swatch.attr('data-variant-url');

if (!variantUrl) {
  return;
}

$productCard.find('a').each(function () {

  const $link = $(this);

  /*
   * Don't modify wishlist links.
   */
  if (
    $link.closest(
      '.collection-wishlist-icon'
    ).length
  ) {
    return;
  }

  $link.attr(
    'href',
    variantUrl
  );

});


};

/*

=====================================================

GET ACTIVE SWATCH

=====================================================
*/
const getActiveSwatch = ($productCard) => {

let $activeSwatch =
  $productCard
    .find(
      '.color-swatch.active_shade'
    )
    .first();


/*
 * If no active swatch exists,
 * use the first swatch.
 */
if (!$activeSwatch.length) {

  $activeSwatch =
    $productCard
      .find('.color-swatch')
      .first();


  if ($activeSwatch.length) {

    $productCard
      .find('.color-swatch')
      .removeClass(
        'active_shade'
      );

    $activeSwatch.addClass(
      'active_shade'
    );

  }

}

return $activeSwatch;


};

/*

=====================================================

SAVE ORIGINAL SLIDES

=====================================================
*/
const saveOriginalSlides = ($slider) => {

let $originalSlides =
  $slider.data(
    'original-color-slides'
  );


/*
 * Already saved.
 */
if (
  $originalSlides &&
  $originalSlides.length
) {
  return $originalSlides;
}


/*
 * If Slick is already initialized,
 * retrieve the real slides and ignore
 * Slick cloned slides.
 */
if (
  $slider.hasClass(
    'slick-initialized'
  )
) {

  const $slickSlides =
    $slider
      .find(
        '.slick-slide:not(.slick-cloned) > div > .product-image-slide'
      );


  if ($slickSlides.length) {

    $originalSlides =
      $slickSlides.clone(
        false,
        false
      );

  }

}


/*
 * Normal non-Slick HTML.
 */
if (
  !$originalSlides ||
  !$originalSlides.length
) {

  $originalSlides =
    $slider
      .children(
        '.product-image-slide'
      )
      .clone(
        false,
        false
      );

}


/*
 * Store original slides.
 */
if (
  $originalSlides &&
  $originalSlides.length
) {

  $slider.data(
    'original-color-slides',
    $originalSlides
  );

}

return $originalSlides;


};

/*

=====================================================

DESTROY SLICK SAFELY

=====================================================
*/
const destroySlider = ($slider) => {

if (
  !$slider.hasClass(
    'slick-initialized'
  )
) {
  return;
}

try {

  $slider.slick(
    'unslick'
  );

} catch (error) {

  console.warn(
    'Could not destroy Slick:',
    error
  );

}


};

/*

=====================================================

SLICK ARROWS

=====================================================
*/
const prevArrow = '<button class="img-arrow img-prev" type="button">' +
      '<svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M10.2307 1.68781C10.321 1.59231 10.3915 1.47996 10.4384 1.35719C10.4852 1.23442 10.5074 1.10363 10.5037 0.972287C10.5 0.840941 10.4704 0.711614 10.4167 0.591688C10.363 0.471763 10.2862 0.363588 10.1907 0.27334C10.0952 0.183092 9.98287 0.112538 9.8601 0.065707C9.73733 0.018876 9.60654 -0.00331544 9.4752 0.000400135C9.34385 0.00411571 9.21453 0.0336653 9.0946 0.0873618C8.97467 0.141058 8.8665 0.21785 8.77625 0.313353L0.273433 9.31634C0.0978387 9.50207 0 9.74797 0 10.0036C0 10.2592 0.0978387 10.5051 0.273433 10.6908L8.77625 19.6948C8.8659 19.7924 8.97405 19.8712 9.09442 19.9266C9.21479 19.9821 9.34497 20.013 9.47741 20.0177C9.60985 20.0224 9.7419 20.0008 9.8659 19.954C9.9899 19.9073 10.1034 19.8364 10.1997 19.7454C10.2961 19.6544 10.3734 19.5451 10.4272 19.424C10.481 19.3029 10.5101 19.1723 10.513 19.0398C10.5159 18.9073 10.4924 18.7756 10.444 18.6522C10.3955 18.5289 10.323 18.4164 10.2307 18.3213L2.37613 10.0036L10.2307 1.68781Z" fill="black"/>' +
      '</svg>' +
    '</button>';

const nextArrow = '<button class="img-arrow img-next" type="button"><svg width="11" height="21" viewBox="0 0 11 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L10 10.5L1 20" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' ;

/*

=====================================================

BUILD SLIDER

=====================================================
*/
const buildSlider = ($slider, color) => {

if (!$slider.length) {
  return;
}


/*
 * Get ORIGINAL slides.
 *
 * IMPORTANT:
 * Always get the complete original set BEFORE
 * applying color or image limit.
 */
const $originalSlides =
  saveOriginalSlides($slider);


if (
  !$originalSlides ||
  !$originalSlides.length
) {
  return;
}


/*
 * Normalize color.
 */
color =
  String(color || '')
    .toLowerCase()
    .trim();


/*
 * =================================================
 * DESTROY EXISTING SLICK
 * =================================================
 */
destroySlider($slider);


/*
 * =================================================
 * FILTER BY COLOR
 * =================================================
 */
let $filteredSlides;


if (color) {

  $filteredSlides =
    $originalSlides.filter(
      function () {

        const imageColor =
          String(
            $(this).attr(
              'data-color'
            ) || ''
          )
            .toLowerCase()
            .trim();


        return (
          imageColor === color
        );

      }
    );


  /*
   * IMPORTANT:
   *
   * If this is a color-specific card and there
   * are no images for that color, DON'T fall back
   * to all product images.
   *
   * This prevents:
   *
   * Black -> Black images
   * Black -> all images
   *
   * which was causing inconsistent image counts.
   */
  if (
    !$filteredSlides.length
  ) {

    $filteredSlides =
      $originalSlides;

  }

} else {

  /*
   * No active color:
   * use all original images.
   */
  $filteredSlides =
    $originalSlides;

}


/*
 * =================================================
 * APPLY IMAGE LIMIT
 * =================================================
 *
 * IMPORTANT:
 *
 * The limit is applied AFTER color filtering.
 *
 * Example:
 *
 * Original:
 * Black 1
 * Black 2
 * Black 3
 * Black 4
 * Brown 1
 * Brown 2
 *
 * img_limit = 2
 *
 * Black -> Black 1, Black 2
 * Brown -> Brown 1, Brown 2
 *
 * NOT:
 * Black 1, Black 2 globally.
 */
const imageLimit =
  getProductImageLimit();


if (
  imageLimit !== null &&
  $filteredSlides.length > imageLimit
) {

  $filteredSlides =
    $filteredSlides.slice(
      0,
      imageLimit
    );

}


/*
 * =================================================
 * CLEAR CURRENT SLIDER
 * =================================================
 */
$slider.empty();


/*
 * =================================================
 * ADD FILTERED + LIMITED SLIDES
 * =================================================
 */
$filteredSlides.each(
  function () {

    $slider.append(
      $(this).clone(
        false,
        false
      )
    );

  }
);


/*
 * =================================================
 * GET FINAL SLIDE COUNT
 * =================================================
 */
const slideCount =
  $slider
    .children(
      '.product-image-slide'
    )
    .length;


/*
 * =================================================
 * NO IMAGES
 * =================================================
 */
if (!slideCount) {
  return;
}


/*
 * =================================================
 * ONE IMAGE
 *
 * Don't initialize Slick.
 * =================================================
 */
if (
  slideCount === 1
) {

  $slider
    .children(
      '.product-image-slide'
    )
    .first()
    .show();

  return;

}


/*
 * =================================================
 * MULTIPLE IMAGES
 * =================================================
 */
$slider.slick({

  slidesToShow: 1,
  slidesToScroll: 1,

  arrows: true,
  dots: false,

  infinite: false,

  speed: 300,

  prevArrow:
    prevArrow,

  nextArrow:
    nextArrow,
    responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: window.swipe === 'arrows',
                dots: window.swipe === 'dots'
              }
            }
          ]

});


/*
 * =================================================
 * FORCE SLICK POSITION AFTER AJAX / RENDER
 * =================================================
 */
requestAnimationFrame(
  () => {

    if (
      $slider.hasClass(
        'slick-initialized'
      )
    ) {

      $slider.slick(
        'setPosition'
      );

    }

  }
);


};

/*

=====================================================

INITIALIZE PRODUCT CARDS

=====================================================
*/
$('.pdp-img-sliders').each(
function () {

const $slider =
$(this);

const $productCard =
$slider.closest(
'.product-card'
);

if (!$productCard.length) {
return;
}

/*

Don't initialize the same slider twice

in the same render cycle.
*/
if (
$slider.data(
'collection-slider-initializing'
)
) {
return;
}

$slider.data(
'collection-slider-initializing',
true
);

/*

Get active swatch.
*/
const $activeSwatch =
getActiveSwatch(
$productCard
);

/*

No color swatches.
*/
if (!$activeSwatch.length) {

buildSlider(
$slider,
''
);

$slider.removeData(
'collection-slider-initializing'
);

return;

}

/*

Get active color.
*/
const activeColor =
String(
$activeSwatch.attr(
'data-color'
) || ''
)
.toLowerCase()
.trim();

/*

Update variant URL.
*/
updateProductCardUrl(
$productCard,
$activeSwatch
);

/*

Build color-specific slider.

Image limit is applied inside buildSlider().
*/
buildSlider(
$slider,
activeColor
);

/*

Release initialization lock.
*/
$slider.removeData(
'collection-slider-initializing'
);

}


);

/*

=====================================================

COLOR SWATCH CLICK

=====================================================
*/
$(document)
.off(
'click.collectionColorSwatch',
'.color-swatch'
)
.on(
'click.collectionColorSwatch',
'.color-swatch',
function (e) {

e.preventDefault();
e.stopPropagation();

const $swatch =
$(this);

const selectedColor =
String(
$swatch.attr(
'data-color'
) || ''
)
.toLowerCase()
.trim();

const $productCard =
$swatch.closest(
'.product-card'
);

const $slider =
$productCard
.find(
'.pdp-img-sliders'
)
.first();

if (!$productCard.length) {
return;
}

/*
* Set active swatch.
*/
$productCard
.find(
'.color-swatch'
)
.removeClass(
'active_shade'
);

$swatch.addClass(
'active_shade'
);

/*
* Update variant URL.
*/
updateProductCardUrl(
$productCard,
$swatch
);

/*
* Rebuild slider.
*
* Color filtering happens first,
* then imageLimit is applied.
*/
if ($slider.length) {

 buildSlider(
   $slider,
   selectedColor
 );


}

}
);

/*

=====================================================

NEXT ARROW

=====================================================
*/
$(document)
.off(
'click.collectionImageNext',
'.img-next'
)
.on(
'click.collectionImageNext',
'.img-next',
function (e) {

e.preventDefault();
e.stopPropagation();

const $slider =
$(this)
.closest(
'.product-image-wrapper'
)
.find(
'.pdp-img-sliders'
)
.first();

if (
$slider.hasClass(
'slick-initialized'
)
) {

 $slider.slick(
   'slickNext'
 );


}

}
);

/*

=====================================================

PREVIOUS ARROW

=====================================================
*/
$(document)
.off(
'click.collectionImagePrev',
'.img-prev'
)
.on(
'click.collectionImagePrev',
'.img-prev',
function (e) {

e.preventDefault();
e.stopPropagation();

const $slider =
$(this)
.closest(
'.product-image-wrapper'
)
.find(
'.pdp-img-sliders'
)
.first();

if (
$slider.hasClass(
'slick-initialized'
)
) {

 $slider.slick(
   'slickPrev'
 );


}

}
);

}

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
 
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  // static renderProductGridContainer(html) {
  //   document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
  //     .parseFromString(html, 'text/html')
  //     .getElementById('ProductGridContainer').innerHTML;

  //   document.getElementById('ProductGridContainer')
  //     .querySelectorAll('.scroll-trigger')
  //     .forEach((element) => {
  //       element.classList.add('scroll-trigger--cancel');
  //     });
  // }

  static renderProductGridContainer(html) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

  const newProductGrid = parsedHTML.getElementById('ProductGridContainer');
  const currentProductGrid = document.getElementById('ProductGridContainer');

  if (!newProductGrid || !currentProductGrid) return;

  currentProductGrid.innerHTML = newProductGrid.innerHTML;

  currentProductGrid
    .querySelectorAll('.scroll-trigger')
    .forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

  requestAnimationFrame(() => {
    FacetFiltersForm.initColgridJS();
  });
}

  // static renderProductCount(html) {
  //   const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
  //   const container = document.getElementById('ProductCount');
  //   const containerDesktop = document.getElementById('ProductCountDesktop');
  //   container.innerHTML = count;
  //   container.classList.remove('loading');
  //   if (containerDesktop) {
  //     containerDesktop.innerHTML = count;
  //     containerDesktop.classList.remove('loading');
  //   }
  //   const loadingSpinners = document.querySelectorAll(
  //     '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
  //   );
  //   loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  // }

  static renderProductCount(html) {

  /*
   * =====================================================
   * COUNT ACTUAL PRODUCT CARDS
   * =====================================================
   *
   * Shopify's collection.products_count counts products,
   * but our color filtering can create multiple cards
   * from the same product.
   *
   * Example:
   *
   * Product A
   * → Black card
   * → White card
   *
   * Shopify count = 1
   * Actual cards = 2
   *
   * Therefore count the rendered <li> product cards.
   */

  const productGrid = document.getElementById('ProductGridContainer');

  let count = 0;

  if (productGrid) {
    count = productGrid.querySelectorAll(
      'li.product-slide'
    ).length;
  }

  const container =
    document.getElementById('ProductCount');

  const containerDesktop =
    document.getElementById('ProductCountDesktop');


  /*
   * Update mobile / main count
   */
  if (container) {
    container.textContent = count;
    container.classList.remove('loading');
  }


  /*
   * Update desktop count
   */
  if (containerDesktop) {
    containerDesktop.textContent = count;
    containerDesktop.classList.remove('loading');
  }

}
static updateRenderedProductCount() {

  const productGrid =
    document.getElementById('ProductGridContainer');

  if (!productGrid) return;


  /*
   * Count only the actual product card <li> elements.
   */
  const count =
    productGrid.querySelectorAll(
      'li.product-slide'
    ).length;


  const container =
    document.getElementById('ProductCount');

  const containerDesktop =
    document.getElementById('ProductCountDesktop');


  if (container) {
    container.textContent = count;
  }

  if (containerDesktop) {
    containerDesktop.textContent = count;
  }

}


  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '.mobile-facets__header'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateShopByStyleActive(searchParams) {
  const styleItems = document.querySelectorAll(
    '.shop-by-style[data-style-title], .shop-by-style[data-vendor]'
  );

  if (!styleItems.length) return;

  const params = new URLSearchParams(searchParams || '');

  const selectedTags = params.getAll('filter.p.tag');
  const selectedVendors = params.getAll('filter.p.vendor');

  // Shopify-style handleize
  const handleize = (value) => {
    return String(value || '')
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/[^a-z0-9]+/g, '-')      // Non-alphanumeric -> -
      .replace(/^-+|-+$/g, '');         // Trim -
  };

  // Handleize selected filter values once
  const tagHandles = selectedTags.map(handleize);
  const vendorHandles = selectedVendors.map(handleize);

  styleItems.forEach((item) => {
    let isActive = false;

    // Shop By Style / Tag
    if (item.dataset.styleTitle) {
      const styleHandle = handleize(item.dataset.styleTitle);

      isActive = tagHandles.includes(styleHandle);
    }

    // Shop By House / Vendor
    if (item.dataset.vendor) {
      const vendorHandle = handleize(item.dataset.vendor);

      isActive = vendorHandles.includes(vendorHandle);
    }

    item.classList.toggle('active_opt', isActive);
  });
}

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      FacetFiltersForm.updateShopByStyleActive(searchParams);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  // onSubmitHandler(event) {
  //   event.preventDefault();
  //   const sortFilterForms = document.querySelectorAll('facet-filters-form form');
  //   if (event.srcElement.className == 'mobile-facets__checkbox') {
  //     const searchParams = this.createSearchParams(event.target.closest('form'));
  //     this.onSubmitForm(searchParams, event);
  //   } else {
  //     const forms = [];
  //     const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

  //     sortFilterForms.forEach((form) => {
  //       if (!isMobile) {
  //         if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
  //           forms.push(this.createSearchParams(form));
  //         }
  //       } else if (form.id === 'FacetFiltersFormMobile') {
  //         forms.push(this.createSearchParams(form));
  //       }
  //     });
  //     this.onSubmitForm(forms.join('&'), event);
  //   }
  // }

  onSubmitHandler(event) {
    event.preventDefault();

    const targetForm = event.target.closest('form');

    if (!targetForm) return;

    const isMobile = targetForm.id === 'FacetFiltersFormMobile';

    /*
    * MOBILE FILTERS
    * Keep existing behavior.
    */
    if (isMobile) {
      const searchParams = this.createSearchParams(targetForm);
      this.onSubmitForm(searchParams, event);
      return;
    }

    /*
    * SORTING
    *
    * When sort changes, preserve ALL currently active
    * filter parameters from the URL.
    */
    if (targetForm.id === 'FacetSortForm') {
      const currentParams = new URLSearchParams(window.location.search);

      // Remove existing sorting and pagination
      currentParams.delete('sort_by');
      currentParams.delete('page');

      // Get the newly selected sort value
      const sortParams = new URLSearchParams(
        this.createSearchParams(targetForm)
      );

      const sortBy = sortParams.get('sort_by');

      if (sortBy) {
        currentParams.set('sort_by', sortBy);
      }

      const searchParams = currentParams.toString();

      this.onSubmitForm(searchParams, event);
      return;
    }

    /*
    * DESKTOP FILTERS
    *
    * Keep the existing behavior for normal facet changes.
    */
    const forms = [];

    const sortFilterForms = document.querySelectorAll(
      'facet-filters-form form'
    );

    sortFilterForms.forEach((form) => {
      if (
        form.id === 'FacetSortForm' ||
        form.id === 'FacetFiltersForm' ||
        form.id === 'FacetSortDrawerForm'
      ) {
        forms.push(this.createSearchParams(form));
      }
    });

    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

document.addEventListener('DOMContentLoaded', () => {
  const applyButton = document.getElementById('MobileFiltersApply');
  if (!applyButton) return;

  applyButton.addEventListener('click', () => {
    const form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return;
    form.requestSubmit();
  });
});

document.addEventListener('click', (event) => {
  const clearBtn = event.target.closest('.mobile-facets__clear');
  if (!clearBtn) return;
  event.preventDefault();

  const url = new URL(clearBtn.href, window.location.origin);
  const searchParams = url.search.slice(1);

  FacetFiltersForm.renderPage(searchParams);
});